import { axios } from '@/services/axios';

const updateRaToUser = async ({ platformUserId, userType }) => {
    const res = await axios.post(
        `PlatformUser/${platformUserId}/ConvertTo/${userType}`,
    );
    return res;
};

export default updateRaToUser;
